var _path, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 12.5C12.8358 12.5 12.5 12.8358 12.5 13.25V19.25C12.5 19.6642 12.8358 20 13.25 20H21.25C21.6642 20 22 19.6642 22 19.25V13.25C22 12.8358 21.6642 12.5 21.25 12.5H13.25ZM17.25 14C17.4985 14 17.7 14.2015 17.7 14.45V15.9H19.15C19.3986 15.9 19.6 16.1015 19.6 16.35C19.6 16.5985 19.3986 16.8 19.15 16.8H17.7V18.35C17.7 18.5985 17.4985 18.8 17.25 18.8C17.0015 18.8 16.8 18.5985 16.8 18.35V16.8H15.25C15.0015 16.8 14.8 16.5985 14.8 16.35C14.8 16.1015 15.0015 15.9 15.25 15.9H16.8V14.45C16.8 14.2015 17.0015 14 17.25 14Z",
    fill: "#73ADE9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 12.5,
    width: 9.5,
    height: 7.5,
    rx: 0.75,
    fill: "#F3A23A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 4,
    width: 9.5,
    height: 7.5,
    rx: 0.75,
    fill: "#B35F9A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 9.5,
    height: 7.5,
    rx: 0.75,
    fill: "#7CB141"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/Courses.5e7107ad02405820313cdc1772b475e8.svg";
export { ForwardRef as ReactComponent };